import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { map, tap } from "rxjs/operators";
import { SaveService } from "../services/save.service";
import { ApiService } from "../services/api.service";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: "app-download",
  templateUrl: "./download.component.html",
  styleUrls: ["./download.component.css"],
  providers: [ApiService]
})
export class DownloadComponent implements OnInit {
  brandName;
  secondBrandName;
  sendno: any = "";
  sendmessageClass: any = "";
  sendmessageStatus: any = "";

  slides = [
    {
      icon: "../assets/images/behalf-icon1.png",
      heading: "Search for the best price"
    },
    { icon: "../assets/images/behalf-icon2.png", heading: "Get your card" },
    {
      icon: "../assets/images/behalf-icon3.png",
      heading: "Show pharmacist at time of purchase"
    }
  ];

  slides2 = [
    {
      heading: "Honest Discounts iOS App user",
      text:
        "I have been using Honest Discount from 2017. Till now I feel very comfortable and cancelled my SBI account after using paytm. Hope you start using Honest Discount. love you",
        rating:'5/3',
        enable:'3'
    },
    {
      heading: "Honest Discounts iOS App user",
      text:
        "I have been using Honest Discount from 2017. Till now I feel very comfortable and cancelled my SBI account after using paytm. Hope you start using Honest Discount. love you",
        rating:'5/4',
        enable:'4'
    },
    {
      heading: "Honest Discounts iOS App user",
      text:
        "I have been using Honest Discount from 2017. Till now I feel very comfortable and cancelled my SBI account after using paytm. Hope you start using Honest Discount. love you",
        rating:'5/1',
        enable:'1'
    },
    {
      heading: "Honest Discounts iOS App user",
      text:
        "I have been using Honest Discount from 2017. Till now I feel very comfortable and cancelled my SBI account after using paytm. Hope you start using Honest Discount. love you",
        rating:'5/5',
        enable:'5'
    }
  ];

  slideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: "<div class='nav-btn next-slide'></div>",
    prevArrow: "<div class='nav-btn prev-slide'></div>",
    dots: true,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  slideConfig2 = {
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: "<div class='nav-btn next-slide'></div>",
    prevArrow: "<div class='nav-btn prev-slide'></div>",
    dots: true,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  constructor(private saveService: SaveService, private savecard: ApiService, public router: Router) {
    this.router.events.subscribe((ev:any) => {
      if (ev instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
  ngOnInit() {
    this.brandName = this.saveService.getBrandName();
    this.secondBrandName = this.saveService.getSecondBrandName();
  }

  sendmsg(val, downloadbottom) {
    console.log(val);
    // debugger;
    if (val != "" && val.length >= 7) {
      this.savecard
        .sendSms(val)
        .pipe(
          tap(
            data => {
              // debugger;
            },
            error => {
              // debugger;
              let errorData = (this.sendmessageStatus = JSON.parse(
                error._body
              ));
              if (errorData.code == "21408") {
                this.sendmessageStatus = "Please enter country code!";
                this.sendmessageClass = "msgerror";
              } else if (errorData.code == "21211") {
                this.sendmessageStatus = "Invalid Number";
                this.sendmessageClass = "msgerror";
              } else {
                this.sendmessageStatus = "Try a different number";
                this.sendmessageClass = "msgerror";
              }
            }
          )
        )
        .subscribe(data => {
          debugger;
          this.sendmessageStatus = "Message Sent";
          if (downloadbottom != "downloadbottom") {
            this.sendmessageClass = "Success_sent";
          } else {
            this.sendmessageClass = "Success_sent d_bottom";
          }
          setTimeout(() => {
            this.sendmessageClass = "";
            this.sendmessageStatus = "";
            this.sendno = "";
          }, 6000);
        });
    } else {
      this.sendmessageStatus = "Please enter a valid phone number";
      this.sendmessageClass = "msgerror";
    }

    /*
    var phoneNumber = val // +919812345678, +442071234567
    var linkData = {
      campaign: 'Microsite form Data'
    };
    var linkOptions = {
      make_new_link: false // don't create a new deep link if one already exists (e.g. _branch_match_id is in the address bar)
    };
    (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})
    (window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);              
      // init Branch
      this.branch.init('key_test_kbVA7KLYjQr3IhziIq9prflaBwjkef5p');
      // document.getElementById("myBtn").addEventListener("click", function(){
      this.branch.sendSMS(val, linkData, linkOptions, function(err, data) {
      console.log(err);
    });
    */
  }
  removemsgerr(e) {
    this.sendmessageStatus = "";
    this.sendmessageClass = "";
    e = e || window.event;
    var charCode = typeof e.which == "number" ? e.which : e.keyCode;
    if (!charCode || charCode == 8 /* Backspace */) {
      return;
    }

    var typedChar = String.fromCharCode(charCode);

    // Allow numeric characters
    if (/\d/.test(typedChar)) {
      return;
    }

    // Allow the minus sign (+) if the user enters it first
    if (typedChar == "+" && e.target.value.charAt() == "") {
      return;
    }
    return false;
  }
}
